// Line icons drawn in the current text colour, so they sit with the sidebar's
// icons and follow the theme. Use these rather than emoji for statuses and
// small markers on a screen.
//
// Whereabouts statuses carry an emoji in the database for the planner grid;
// WhereIcon maps the status code to a line icon instead, and falls back to the
// stored emoji for a code it does not know.

const PATHS = {
  office: <><path d="M4 21V5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v16" /><path d="M15 9h4a1 1 0 0 1 1 1v11" /><path d="M3 21h18" /><path d="M8 8h3M8 12h3M8 16h3" /></>,
  home: <><path d="M3 11l9-7 9 7" /><path d="M5 10v10h14V10" /><path d="M10 20v-5h4v5" /></>,
  offsite: <><path d="M12 21s-7-6.2-7-11.5A7 7 0 0 1 19 9.5C19 14.8 12 21 12 21z" /><circle cx="12" cy="9.5" r="2.5" /></>,
  leave: <><circle cx="12" cy="12" r="4" /><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" /></>,
  not_working: <path d="M20 14.5A8 8 0 0 1 9.5 4 8 8 0 1 0 20 14.5z" />,
  clock: <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>,
  alert: <><path d="M10.3 3.9L2.4 18a2 2 0 0 0 1.7 3h15.8a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z" /><path d="M12 9v4M12 17h.01" /></>,
  van: <><path d="M3 7h11v9H3z" /><path d="M14 10h4l3 3v3h-7" /><circle cx="7" cy="17.5" r="1.5" /><circle cx="17" cy="17.5" r="1.5" /></>,
  desk: <><path d="M3 9h18M5 9v11M19 9v11M5 14h14" /></>,
  flag: <><path d="M5 21V4" /><path d="M5 4h11l-2 4 2 4H5" /></>,
  flame: <path d="M12 3c1 3.5 5 5.5 5 10a5 5 0 0 1-10 0c0-2.2 1.2-3.6 2.3-4.6.3 1.4 1 2.4 2.2 2.8C11 9 11 6 12 3z" />,
};

export function LineIcon({ name, className = 'w-3.5 h-3.5', title }) {
  const d = PATHS[name];
  if (!d) return null;
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
      className={`inline-block flex-shrink-0 align-[-0.15em] ${className}`} aria-hidden={title ? undefined : 'true'} role={title ? 'img' : undefined}>
      {title && <title>{title}</title>}
      {d}
    </svg>
  );
}

// A whereabouts status: its line icon when the code is one we draw, otherwise
// the emoji the status carries.
export function WhereIcon({ code, fallback, className }) {
  if (PATHS[code]) return <LineIcon name={code} className={className} />;
  return fallback ? <span aria-hidden="true">{fallback}</span> : null;
}


export const LINE_ICON_NAMES = Object.keys(PATHS);
